import { render, staticRenderFns } from "./fs-portal.vue?vue&type=template&id=4219ef34&scoped=true"
import script from "./fs-portal.vue?vue&type=script&lang=js"
export * from "./fs-portal.vue?vue&type=script&lang=js"
import style0 from "./fs-portal.vue?vue&type=style&index=0&id=4219ef34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4219ef34",
  null
  
)

export default component.exports